import { createSlice as i } from "@reduxjs/toolkit";
const t = "quantum_data_sharing", n = () => {
  if (typeof sessionStorage < "u") {
    const a = sessionStorage.getItem(t);
    if (a)
      return JSON.parse(a);
  }
  return {};
}, o = { data: n() }, r = i({
  name: "dataSharing",
  initialState: o,
  reducers: {
    saveData: (a, e) => {
      if (a.data = { ...a.data, [e.payload.key]: e.payload.value }, typeof sessionStorage < "u" && e.payload.isPersist) {
        const s = JSON.parse(sessionStorage.getItem(t) || "{}");
        s[e.payload.key] = e.payload.value, sessionStorage.setItem(t, JSON.stringify(s));
      }
    }
  }
}), { saveData: S } = r.actions;
export {
  r as d,
  S as s
};
